import ArrowLeftIcon from '../../assets/arrow-left-white-icon.svg';

const GoBackButton = ({ onClick, top }) => {
  return (
    <div
      className={`p-1 md:p-2 rounded-[80px] absolute left-[16px] md:left-[60px] ${top || 'top-[10px] md:top-[60px]'} z-50 h-fit bg-growth-green-500 cursor-pointer hover:opacity-80 transition duration-200`}
      onClick={onClick}
    >
      <img className="max-w-5 max-h-5 min-w-5 min-h-5" src={ArrowLeftIcon} alt="" />
    </div>
  );
};

export default GoBackButton;
